<script setup lang="ts">
import { mdiArrowLeftBold } from '@mdi/js'

const runtimeConfig = useRuntimeConfig()

const route = useRoute()
const { data: docs } = await useAsyncData(route.path, () => queryCollection('content').path(route.path.toLowerCase()).first())

useSeoMeta({
  title: `${docs.value?.title} | Code & Magic`,
  description: docs.value?.description || '夢中になれたら、学びも遊び。楽しむことから始める、紙とウェブのプログラミング教材。',
  ogTitle: `${docs.value?.title} | Code & Magic`,
  ogDescription:
    docs.value?.description || '夢中になれたら、学びも遊び。楽しむことから始める、紙とウェブのプログラミング教材。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  layout: 'document',
})
</script>

<template>
  <div>
    <v-app-bar app>
      <v-fab
        extended
        :prepend-icon="mdiArrowLeftBold"
        text="ホームに戻る"
        variant="text"
        size="large"
        to="/"
        class="back-button"
      />
    </v-app-bar>
    <v-container class="container">
      <template v-if="docs">
        <ContentRenderer
          :value="docs"
          class="container"
        />
      </template>
      <template v-else>
        <div class="empty-page">
          <h1>Page Not Found</h1>
          <p>Oops! The content you're looking for doesn't exist.</p>
          <NuxtLink to="/">Go back home</NuxtLink>
        </div>
      </template>
    </v-container>
  </div>
</template>

<style scoped>
.container {
  background-color: #fff;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 1rem;
}

.container .back-button {
  background-color: #fff;
}

.container :deep(h1) {
  font-size: 2.3rem;
  color: #111;
}

.container :deep(h2) {
    margin-top: 0.8rem;
}

.container :deep(h2 a) {
  font-size: 1.8rem;
  color: #111;
  text-decoration: none;

}

.container :deep(h3) {
    margin-top: 0.6rem;
}

.container :deep(h3 a) {
  font-size: 1.3rem;
  color: #111;
  text-decoration: none;
}

.container :deep(h4) {
    margin-top: 0.6rem;
}

.container :deep(h4 a) {
  font-size: 1.1rem;
  color: #111;
  text-decoration: none;
}

.container :deep(ol), :deep(ul) {
  padding-left: 1.5rem;
}

.container :deep(ol ul) {
  padding-left: 1.4rem;
}

.container :deep(table) {
  background-color: whitesmoke;
  border-radius: 8px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);

  margin: 1.5em 2rem;
  padding: 1.5em;
}

.container :deep(table th) {
  /* width: 40%; */
  text-align: left;
  border-bottom: 1px solid black;
}

.container :deep(table td) {
  /* width: 60%; */
  text-align: left;
  border-bottom: 1px solid black;
}
</style>
